/**
 * @generated SignedSource<<0596fbf9142f93d05d6611851e2986d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type newsletterArticleArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"contentNewsletterArticleArticle" | "headerNewsletterArticleArticle" | "issuesNewsletterArticleArticle" | "widgetNewsletterArticleArticle">;
  readonly " $fragmentType": "newsletterArticleArticle";
};
export type newsletterArticleArticle$key = {
  readonly " $data"?: newsletterArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"newsletterArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "newsletterArticleArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentNewsletterArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerNewsletterArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "issuesNewsletterArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "widgetNewsletterArticleArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "876df60ff2f7b93c0c98303fac90fedd";

export default node;
